import { Controller } from "@hotwired/stimulus";
import { CSSPlugin, gsap, Power4 } from "gsap/all";

gsap.registerPlugin(CSSPlugin);

export default class extends Controller {
  static targets = ["content", "icon"];

  static values = {
    duration: Number,
    isOpen: Boolean,
    marginTop: String,
  };

  connect() {
    this.animationDuration = this.durationValue || 0.4;
    this.isOpen = this.isOpenValue || false;
    this.isAnimating = false;

    // Initial state
    this.isOpen
      ? this.openCollapseAnimation(0)
      : this.closeCollapseAnimation(0);
  }

  handleClickButton() {
    !this.isOpen
      ? this.openCollapseAnimation(this.animationDuration)
      : this.closeCollapseAnimation(this.animationDuration);
    this.isOpen = !this.isOpen;
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('collapse:toggle'))
    }, this.animationDuration * 1000)
  }

  clickOutsideHandler(e) {
    if (!this.element.contains(e.target)) {
      this.closeCollapseAnimation(this.animationDuration);
    }
  }

  closeCollapseAnimation(duration) {
    const tl = new gsap.timeline();
    const animProps = { height: 0, ease: Power4.easeOut, duration: duration };
    if (this.hasMarginTopValue) animProps.marginTop = 0;

    tl.to(this.contentTarget, { overflow: "hidden", duration: 0 });
    tl.to(this.contentTarget, animProps, "start");

    if (this.hasIconTarget) {
      tl.to(
        this.iconTarget,
        { rotate: 0, ease: Power4.easeOut, duration: duration },
        "start"
      );
    }
  }

  openCollapseAnimation(duration) {
    const tl = new gsap.timeline();
    const animProps = { height: "auto", ease: Power4.easeOut, duration: duration };
    if (this.hasMarginTopValue) animProps.marginTop = this.marginTopValue;

    if (this.hasIconTarget) {
      tl.to(
        this.iconTarget,
        { rotate: 90, ease: Power4.easeOut, duration: duration },
        "start"
      );
    }

    tl.to(this.contentTarget, animProps, "start");
    tl.to(this.contentTarget, { overflow: "visible", duration: 0 });
  }
}
